<template>
  <SustainabilityNavBar
    title="SUSTAINABILITY REPORT 2022"
    :sections="content"
  />
  <HeadlessLayout :sections="content" />
</template>

<script>
import { mapActions } from "vuex";
import HeadlessLayout from "@/layouts/HeadlessLayout.vue";
import SustainabilityReportContent from "@/content/SustainabilityReport.json";
import SustainabilityNavBar from "@/components/sustainability/SustainabilityNavBar.vue";

export default {
  name: "SustainabilityReport",
  components: {
    HeadlessLayout,
    SustainabilityNavBar,
  },
  data() {
    return {
      content: SustainabilityReportContent,
    };
  },
  created() {
    const app = document.querySelector("#app");
    app.classList.remove("fixed-header");
  },
  mounted() {
    const url = new URL(window.location);
    const sectionSlug = url.searchParams.get("section");

    if (sectionSlug) {
      const matchedSection = this.content.find(
        (section) => section.slug === sectionSlug
      );

      window.addEventListener("load", () => {
        if (matchedSection) {
          this.updateSelectedSection({
            section: matchedSection.slug,
            navigate: true,
          });
        }
      });
    }
  },
  methods: {
    ...mapActions("sustainability", ["updateSelectedSection"]),
  },
};
</script>
